import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MediaPartners() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api
      .get("/media-partners")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <section
      className="border-t av-hairline bg-[#141210]/40"
      data-testid="media-partners"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          <span className="av-eyebrow">Media Partner & Collaboratori</span>
          <h2 className="font-serif-display text-3xl sm:text-5xl mt-3 leading-tight">
            Le realtà che{" "}
            <span className="italic text-[#E5A93C]">camminano con noi</span>.
          </h2>
          <p className="text-[#A39E93] mt-4 max-w-2xl mx-auto text-sm sm:text-base">
            Testate, emittenti, enti, associazioni e partner di lavoro che
            seguono e supportano le produzioni NMA Agency.
          </p>
        </div>

        {items.length === 0 ? (
          <div
            className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4"
            data-testid="media-partners-placeholder"
          >
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                key={i}
                className="border-2 border-dashed border-[#A39E93]/25 rounded-lg h-24 flex items-center justify-center text-[#A39E93]/60 text-xs text-center px-3"
              >
                Logo partner {i + 1}
              </div>
            ))}
          </div>
        ) : (
          <div
            className="mt-12 flex flex-wrap justify-center gap-4"
            data-testid="media-partners-list"
          >
            {items.map((p) => {
              const inner = (
                <div className="w-full h-24 flex items-center justify-center bg-white rounded-lg border av-hairline p-3 transition-all hover:border-[#E5A93C]/70 hover:shadow-[0_0_0_2px_rgba(229,169,60,0.15)]">
                  <img
                    src={p.logo_url}
                    alt={p.name}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
              );
              return p.link ? (
                <a
                  key={p.id}
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-36 sm:w-40 md:w-44 lg:w-48"
                  data-testid={`media-partner-${p.id}`}
                  title={p.name}
                >
                  {inner}
                </a>
              ) : (
                <div
                  key={p.id}
                  className="block w-36 sm:w-40 md:w-44 lg:w-48"
                  data-testid={`media-partner-${p.id}`}
                  title={p.name}
                >
                  {inner}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
